import { takeLatest, put, call } from 'redux-saga/effects';

import { findVeiculoCadastro } from '../service';
import {
  FIND_VEICULO_CADASTRO,
  FIND_VEICULO_CADASTRO_PENDING,
  FIND_VEICULO_CADASTRO_SUCCESS,
  FIND_VEICULO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindVeiculoCadastro(action) {
  yield put({ type: FIND_VEICULO_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findVeiculoCadastro, action.id);

    yield put({ type: FIND_VEICULO_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_VEICULO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindVeiculoCadastro() {
  yield takeLatest(FIND_VEICULO_CADASTRO, sagaFindVeiculoCadastro)
}
